import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Heart, Star } from 'lucide-react';
import '../../../../assets/css/screens/customer/dashboard/favorites/Favorites.css';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';

// Dummy favorites data
const DUMMY_FAVORITES = [
  {
    id: 1,
    name: 'John Smith',
    service: 'Electrical Services',
    rating: 4.8,
    reviews: 156,
    price: 'Rs 500/hr',
    image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&q=80',
    verified: true
  },
  {
    id: 2,
    name: 'Sarah Miller',
    service: 'Cleaning Services',
    rating: 4.9,
    reviews: 234,
    price: 'Rs 400/hr',
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400&q=80',
    verified: true
  },
  {
    id: 3,
    name: 'Mike Johnson',
    service: 'Plumbing Services',
    rating: 4.7,
    reviews: 189,
    price: 'Rs 600/hr',
    image: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=400&q=80',
    verified: true
  },
  {
    id: 4,
    name: 'Emily Davis',
    service: 'Painting Services',
    rating: 4.8,
    reviews: 198,
    price: 'Rs 450/hr',
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=400&q=80',
    verified: true
  }
];

const Favorites = () => {
  const navigate = useNavigate();
  const [favorites, setFavorites] = useState(DUMMY_FAVORITES);

  const handleBack = () => {
    navigate(-1);
  };

  const handleRemoveFavorite = (id) => {
    setFavorites(prev => prev.filter(item => item.id !== id));
  };

  const handleCardClick = (id) => {
    navigate(`/worker/${id}`);
  };

  return (
    <>
    <AppNavbar/>
    
    <div className="favorites-page">
      
      {/* Header */}
      <div className="favorites-header">
        <button className="favorites-back" onClick={handleBack}>
          <ArrowLeft size={24} />
        </button>
        <h2 className="favorites-title">Favorites</h2>
      </div>

      {/* Content */}
      <div className="favorites-content">
        
        {favorites.length > 0 ? (
          /* Favorites Grid */
          <div className="favorites-grid">
            {favorites.map((worker) => (
              <div
                key={worker.id}
                className="favorite-card"
                onClick={() => handleCardClick(worker.id)}
              >
                {/* Image */}
                <div className="favorite-card-img-wrap">
                  <img 
                    src={worker.image} 
                    alt={worker.name} 
                    className="favorite-card-img"
                  />
                  {/* Heart Button */}
                  <button 
                    className="favorite-card-heart"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveFavorite(worker.id);
                    }}
                  >
                    <Heart size={20} fill="#ef4444" color="#ef4444" />
                  </button>
                </div>

                {/* Info */}
                <div className="favorite-card-body">
                  <h5 className="favorite-card-name">{worker.name}</h5>
                  <p className="favorite-card-service">{worker.service}</p>
                  
                  {/* Rating */}
                  <div className="favorite-card-rating">
                    <Star size={14} fill="#fbbf24" color="#fbbf24" />
                    <span className="favorite-card-rating-value">{worker.rating}</span>
                    <span className="favorite-card-reviews">({worker.reviews})</span>
                  </div>

                  {/* Price */}
                  <div className="favorite-card-price">{worker.price}</div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          /* Empty State */
          <div className="favorites-empty">
            <Heart size={80} color="#cbd5e1" strokeWidth={1.5} />
            <h2 className="favorites-empty-title">No favorites yet</h2>
            <p className="favorites-empty-desc">
              Tap the heart icon on a worker's profile to save them here
            </p>
          </div>
        )}

      </div>

    </div>
    </>
  );
};

export default Favorites;